export const estadoTiempo: any = {
    DNF: 'DNF',
    DNS: 'DNS',
    DPP : 'DPP'
  };
